<template>
  <div id="loading-container">
    <div id="loading-banner">
      <spin-loader is-large/>
    </div>
  </div>
</template>

<style>
#loading-container {
  position: fixed;
  top: 0;
  left: 0;
  background-color: #ffffff99;
  width: 100%;
  height: 100%;

  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

#loading-banner {
  width: 250px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
</style>
